// extracted by mini-css-extract-plugin
export default {"container":"SportsmanRatingInfo_container__xIt-f","heading":"SportsmanRatingInfo_heading__T2bFs"};